import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import FormEdit from '../../../../components/auth/diario/listar/form_edit'
import Head from '../../../../components/head'


function EditarDiarioScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Diário" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarDiarioScreen;